// extracted by mini-css-extract-plugin
export default {"menuButton":"menuButton_menuButton__30gHG","line1":"menuButton_line1__+SGKH","line2":"menuButton_line2__fJ97c","line3":"menuButton_line3__CwngK","opened":"menuButton_opened__RXNQ7"};